export default __webpack_public_path__ + "static/media/nonamecall.26c52683.svg";